/* eslint-disable no-underscore-dangle */
export const fetchAccessTokens = (query = '') =>
  fetch(`/api/tokens?${query}`, {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
  }).then((response) => response.json());

export const createAccessToken = (postData: Record<string, unknown> = {}) =>
  fetch('/api/tokens', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ _csrf_token: (window as any)._csrf_token, ...postData }),
  }).then((response) => {
    if (!response.ok) {
      throw response.json();
    }
    return response.json();
  });

export const deleteAccessToken = (token) =>
  fetch(`/api/tokens/${token}`, {
    method: 'DELETE',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ _csrf_token: (window as any)._csrf_token }),
  }).then((response) => {
    if (!response.ok) {
      throw response.json();
    }
    /* do something */
  });
